import React from "react";
import { CgClose, CgInfo } from "react-icons/cg";
import { useNavigate } from "react-router-dom";

import "./Task.css";

const Task = ({ task, handleTaskClick, Removetask, HandleClickTaskDetails }) => {
	const history = useNavigate();

	const handleTaskDetailsClick = () => {
		history(`/TaskList/${task.title}`);
		HandleClickTaskDetails(task.id)
	};

	return (
		<div
			className="task-container"
			style={task.status ? { borderLeft: "6px solid chartreuse" } : {}}
		>
			<div className="task-title" onClick={() => handleTaskClick(task.id)}>
				{task.title}
			</div>

			<div className="buttons-container">
				<button
					className="remove-task-button"
					onClick={() => Removetask(task.id)}
				>
					<CgClose />
				</button>
				<button
					className="see-task-details-button"
					onClick={handleTaskDetailsClick}
					>
					<CgInfo />
				</button>
			</div>
		</div>
	);
};

export default Task;